import MuiDialogContent, { DialogContentProps as MuiDialogContentProps } from '@mui/material/DialogContent';

import * as React from 'react';

import { toSxArray } from '_lib/utils/helpers';

export type DialogContentProps = MuiDialogContentProps;

export const DialogContent = (props: DialogContentProps) => {
  const { sx, ...rest } = props;
  return <MuiDialogContent sx={[{ padding: 1.5 }, ...toSxArray(sx)]} {...rest} />;
};
